var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.295,
    r: 15,
    fill: "#017E89"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5813_4415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.005 18.1878C19.9204 15.1821 19.6796 15.5571 19.7348 15.4788C20.4322 14.4952 20.8008 13.3375 20.8008 12.1309C20.8008 8.93094 18.2041 6.29492 15 6.29492C11.8063 6.29492 9.19922 8.92573 9.19922 12.1309C9.19922 13.3367 9.57553 14.5247 10.2957 15.5215L11.9949 18.1878C10.1782 18.467 7.08984 19.2989 7.08984 21.1309C7.08984 21.7987 7.52571 22.7503 9.60218 23.4919C11.0521 24.0097 12.9691 24.2949 15 24.2949C18.7978 24.2949 22.9102 23.2236 22.9102 21.1309C22.9102 19.2986 19.8254 18.4675 18.005 18.1878ZM11.1767 14.9414C11.1709 14.9324 11.1649 14.9235 11.1585 14.9148C10.5592 14.0903 10.2539 13.1132 10.2539 12.1309C10.2539 9.49351 12.3776 7.34961 15 7.34961C17.617 7.34961 19.7461 9.49446 19.7461 12.1309C19.7461 13.1147 19.4465 14.0587 18.8796 14.8615C18.8288 14.9285 19.0939 14.5167 15 20.9406L11.1767 14.9414ZM15 23.2402C10.8518 23.2402 8.14453 22.0209 8.14453 21.1309C8.14453 20.5326 9.53559 19.549 12.6181 19.1656L14.5553 22.2053C14.6521 22.3573 14.8198 22.4492 15 22.4492C15.1801 22.4492 15.3479 22.3572 15.4447 22.2053L17.3818 19.1656C20.4644 19.549 21.8555 20.5326 21.8555 21.1309C21.8555 22.0134 19.1726 23.2402 15 23.2402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.49414C13.5461 9.49414 12.3633 10.677 12.3633 12.1309C12.3633 13.5847 13.5461 14.7676 15 14.7676C16.4539 14.7676 17.6367 13.5847 17.6367 12.1309C17.6367 10.677 16.4539 9.49414 15 9.49414ZM15 13.7129C14.1277 13.7129 13.418 13.0032 13.418 12.1309C13.418 11.2585 14.1277 10.5488 15 10.5488C15.8723 10.5488 16.582 11.2585 16.582 12.1309C16.582 13.0032 15.8723 13.7129 15 13.7129Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5813_4415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 6.29492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFooter);
export default __webpack_public_path__ + "static/media/location-footer.ee4aa3e0fc9f023ce8705129d106342a.svg";
export { ForwardRef as ReactComponent };